import { render, staticRenderFns } from "./page.vue?vue&type=template&id=033f3273"
import script from "./page.ts?vue&type=script&lang=ts&external"
export * from "./page.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { FormWrapper as VivaFormWrapper } from '@/core/components'
installComponents(component, {VivaFormWrapper})
